import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';
import audible from 'assets/Home/audible.svg';
import headspace from 'assets/Home/headspace.svg';
import bag from 'assets/Home/home_bag.png';
import heart from 'assets/Home/home_heart.png';
import tidal from 'assets/Home/tidal.svg';
import yoga_club from 'assets/Home/yoga_club.svg';
import { desktop } from '../utils/mediaQueries';
const messages = defineMessages({
    spendHeading: 'Have fun',
    spendText: 'Compete in challenges, collect badges, and join a community of movers that turn their steps into gadgets, digital subscriptions, travel vouchers, or even crypto. Yes, anti-gravity yoga is on the list',
    workHeading: 'Put your steps to work',
    workText: 'Join a charity challenge and walk with purpose',
    findOutMore: 'Find out more',
    exchangeHeading: 'Exchange',
    exchangeText: 'you can now convert Sweatcoins into SWEAT. Find out more about how you can opt into, and start generating, SWEAT with your steps.',
});
const SimpleSteps = () => {
    const [toggle, setToggle] = useState(true);
    useEffect(() => {
        const interval = setInterval(() => {
            setToggle((toggle) => !toggle);
        }, 3000);
        return () => clearInterval(interval);
    }, []);
    return (_jsxs(Wrapper, { id: "how-it-works", children: [_jsxs(Block, { children: [_jsxs(ContentLeft, { children: [_jsx(BlockTitle, { children: _jsx(FormattedMessage, Object.assign({}, messages.spendHeading)) }), _jsx(Text, { children: _jsx(FormattedMessage, Object.assign({}, messages.spendText)) }), _jsx(LogosTop, { children: toggle ? (_jsxs(_Fragment, { children: [_jsx("img", { src: headspace, width: "152", height: "34", alt: "Headspace logo" }), _jsx("img", { src: yoga_club, width: "142", height: "34", alt: "Yogaclub logo" })] })) : (_jsxs(_Fragment, { children: [_jsx("img", { src: audible, width: "113", height: "32", alt: "Audible logo", style: { transform: 'translateY(-7px)' } }), _jsx("img", { src: tidal, width: "166", height: "23", alt: "Tidal logo" })] })) })] }), _jsx(CoverRight, { children: _jsx(Bag, { children: _jsx(LazyLoadImage, { src: bag, width: "490", height: "435", alt: "Spend image" }) }) })] }), _jsxs(Block, { children: [_jsx(CoverLeft, { children: _jsx(Heart, { src: heart, children: _jsx(LazyLoadImage, { src: heart, width: "518", height: "394", alt: "Donate image" }) }) }), _jsxs(ContentRight, { children: [_jsx(BlockTitle, { children: _jsx(FormattedMessage, Object.assign({}, messages.workHeading)) }), _jsx(Text, { children: _jsx(FormattedMessage, Object.assign({}, messages.workText)) })] })] })] }));
};
const Wrapper = styled.div `
  margin: 0 16px;
  padding: 50px 0 0;

  @media ${desktop()} {
    width: 980px;
    margin: 0 auto;
    padding: 120px 0;
  }
`;
const Block = styled.div `
  position: relative;
  padding-top: 32px;
  padding-bottom: 32px;
  display: flex;
  flex-direction: column;

  @media ${desktop()} {
    display: block;
    padding-top: 70px;
    margin-bottom: 120px;
    padding-bottom: 90px;
  }
`;
const ContentLeft = styled.div `
  order: 2;

  @media ${desktop()} {
    width: 500px;
  }
`;
const ContentRight = styled.div `
  order: 2;

  @media ${desktop()} {
    width: 500px;
    margin-left: 480px;
  }
`;
const BlockTitle = styled.h4 `
  font-weight: 700;
  font-family: 'Inter', sans-serif;
  color: #ffffff;
  font-size: 32px;
  line-height: 1.2;
  margin-bottom: 18px;

  @media ${desktop()} {
    font-size: 40px;
    line-height: 1.4;
    margin-bottom: 24px;
  }
`;
const Text = styled.p `
  font-family: 'Inter', sans-serif;
  color: rgba(255, 255, 255, 0.8);
  font-size: 18px;
  line-height: 1.4;
  margin-bottom: 18px;

  @media ${desktop()} {
    font-size: 24px;
    line-height: 1.6;
    margin-bottom: 20px;
  }
`;
const Logos = styled.div `
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 60px;

  @media ${desktop()} {
    justify-content: center;
  }

  img {
    width: auto;
    height: 26px;
    margin-right: 10px;

    @media ${desktop()} {
      height: 34px;
      margin: 0 35px;
    }

    &:last-child {
      margin-right: 0;

      @media ${desktop()} {
        margin-right: 35px;
      }
    }
  }
`;
const LogosTop = styled(Logos) `
  justify-content: center;

  img {
    max-width: 46%;
    height: auto !important;

    &:first-child {
      margin-right: 20px;

      @media ${desktop()} {
        margin-right: 35px;
      }
    }

    @media ${desktop()} {
      height: 34px;
      margin: 0 35px;
    }
  }
`;
const CoverRight = styled.div `
  order: 1;

  @media ${desktop()} {
    position: absolute;
    top: 0;
    right: 0;
  }
`;
const CoverLeft = styled.div `
  @media ${desktop()} {
    position: absolute;
    top: 0;
    left: 0;
  }
`;
const Bag = styled.div `
  img {
    width: 80%;
    height: auto;
    margin: 0px auto 20px;
    display: block;

    @media ${desktop()} {
      width: 490px;
      position: relative;
      top: 17px;
      right: -38px;
      margin: 0;
    }
  }
`;
const Heart = styled.div `
  img {
    width: 80%;
    height: auto;
    margin: 0 auto 20px;
    display: block;

    @media ${desktop()} {
      width: 518px;
      position: relative;
      top: 40px;
      left: -82px;
      margin: 0;
    }
  }
`;
export default SimpleSteps;
